import  { useMemo, useState } from "react";
import Screen from "../../components/Screen";
import ProfileHeaderSection from "../../components/ProfileHeaderSection";
import * as XLSX from "xlsx"; // Add this import
import { useGetEmployeesAttendance } from "../../hooks/useEmployee";
import DataTable from "../../components/Table/data-table";
import { ArrowUpDown } from "lucide-react";
import { DateRange } from "react-day-picker";
import { format } from "date-fns";

const Attendance = () => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [date, setDate] = useState<DateRange | undefined>({
    from: firstDayOfMonth,
    to: today,
  });

  const fromDate = date?.from ? format(date?.from, "yyyy-MM-dd") : "";
  const toDate = date?.to ? format(date?.to, "yyyy-MM-dd") : "";

  const { employee, isPending } = useGetEmployeesAttendance(fromDate, toDate);
  const [userId, setUserId] = useState<null | number>(null);
  // const { logs } = useGetIndividualAttendance(userId as number);

  const transformedEvents = Array.isArray(employee)
    ? employee
        .map(
          (event: {
            firstname: string;
            lastname: string;
            checkIn: string;
            checkOut: string;
            checkInTime: string;
            checkOutTime: string;
            department: string;
            state: string;
            country: string;
          }) => {
            const {
              firstname,
              lastname,
              checkIn,
              checkInTime,
              checkOut,
              checkOutTime,
              department,
              state,
              country,
            } = event;
            const fullName = firstname + " " + lastname;
            return {
              name: fullName || "N/A",
              checkIn: checkIn || "N/A",
              checkOut: checkOut || "N/A",
              checkInTime: checkInTime || "N/A",
              checkOutTime: checkOutTime || "N/A",
              department: department || "N/A",
              state: state || "N/A",
              country: country || "N/A",
            };
          }
        )
        .reverse()
    : [];

  const eventsExcelExport = Array.isArray(employee)
    ? employee
        .map(
          (event: {
            firstname: string;
            lastname: string;
            checkIn: string;
            checkOut: string;
            checkInTime: string;
            checkOutTime: string;
            department: string;
            state: string;
            country: string;
          }) => {
            const {
              firstname,
              lastname,
              checkIn,
              checkInTime,
              checkOut,
              checkOutTime,
              department,
              state,
              country,
            } = event;
            const fullName = firstname + " " + lastname;
            return {
              Name: fullName || "N/A",
              CheckIn: checkIn || "N/A",
              CheckInTime: checkInTime || "N/A",
              CheckOut: checkOut || "N/A",
              CheckOutTime: checkOutTime || "N/A",
              Department: department || "N/A",
              State: state || "N/A",
              Country: country || "N/A",
            };
          }
        )
        .reverse()
    : [];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(eventsExcelExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, "employee_attendance_data.xlsx");
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: ({ column }: { column: any }) => {
          return (
            <button
              className="flex group"
              onClick={() =>
                column.toggleSorting(column.getIsSorted() === "asc")
              }
            >
              Name
              <ArrowUpDown className="ml-2 h-4 w-4 hidden group-hover:block" />
            </button>
          );
        },
        cell: ({ row }: { row: any }) => {
          return (
            <button
              onClick={() => {
                setUserId(row.original.id);
              }}
              className="text-lightDark"
            >
              {row.original.name || "N/A"}
            </button>
          );
        },
      },
      {
        accessorKey: "checkIn",
        header: "Check In",
        cell: ({ row }: { row: any }) => {
          return (
            <>
              {/* <p className="capitalize">{row.original.checkIn}</p> */}
              <p>{row.original.checkInTime}</p>
            </>
          );
        },
      },
      {
        accessorKey: "checkOut",
        header: "Check Out",
        cell: ({ row }: { row: any }) => {
          return (
            <>
              {/* <p className="capitalize">{row.original.checkOut}</p> */}
              <p>{row.original.checkOutTime}</p>
            </>
          );
        },
      },
      {
        accessorKey: "department",
        header: "Department",
      },
      {
        accessorKey: "state",
        header: "State",
      },
      {
        accessorKey: "country",
        header: "Country",
      },
    ],
    []
  );

  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <div className="border border-[#C0C0C0] w-full lg:mt-2 mt-14 mb-2" />
        <div className="mt-4 flex flex-row justify-between items-center">
          <p className={`text-lightDark `}>Employees Attendance</p>
        </div>
        <div className="border border-[#C0C0C0] w-full mt-2 mb-2" />

        <DataTable
          columns={columns}
          data={transformedEvents}
          date={date}
          setDate={setDate}
          exportExcel={exportToExcel}
          loading={isPending}
          hasHeader
        />
      </Screen>
    </div>
  );
};

export default Attendance;
